import React from 'react';
import { PostContainer } from "./style";
const PostBox = ({ post,onClick }) => {
  return (
    <PostContainer onClick={onClick}>
      <img src={post.cover?.url} alt={post.cover?.alt} />
      <div
        className="cover"
        style={{ backgroundImage: `url(${post.cover?.url})` }}
      ></div>
      <div className="post-data">
        <h2>{post.title?.rendered}</h2>
        <span dangerouslySetInnerHTML={{ __html: post.excerpt?.rendered }} />
      </div>
    </PostContainer>
  );
};
export default React.memo(PostBox);